import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../../config/i18n';
import { formatDate } from '../../../utils/Formatter';

export default function ReviewTravelDates({ booking }) {
  return (
    <div className="reviews__traveldates">
      <div>
        {I18n.t('reviews.accommodation')}: {booking.accommodationTitle}
      </div>
      <div>
        {I18n.t('reviews.travel_dates')}: {formatDate(booking.arrival)} {I18n.t('booking.to')}{' '}
        {formatDate(booking.departure)}
      </div>
      <div>
        {I18n.t('reviews.review_author')}: {booking.firstName}
      </div>
    </div>
  );
}

ReviewTravelDates.propTypes = {
  booking: PropTypes.shape({
    accommodationTitle: PropTypes.string,
    arrival: PropTypes.instanceOf(Date),
    departure: PropTypes.instanceOf(Date),
    firstName: PropTypes.string,
  }).isRequired,
};
